import { useEffect, useRef, useState } from "react";
import Header from "../header/Header";
import Sidebar from "../Sidebar/Sidebar";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import {
  Avatar,
  Button,
  Col,
  message,
  Modal,
  Row,
  Table,
  Input,
  Select,
  Popover,
  Tooltip,
  Badge,
} from "antd";
import {
  SearchOutlined,
  PlusCircleOutlined,
  FilterOutlined,
  UserOutlined,
  LoadingOutlined,
  DownloadOutlined,
  UploadOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  getClientFormStruc,
  getAllClient,
  getClientFormData,
  UploadBulkData,
  UploadClientBulk,
  DeleteClientReq,
} from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Spin } from "antd";
import "react-datepicker/dist/react-datepicker.css";
import "../MasterDatabase/MasterDB.css";
import axios from "axios";
import { getAllCountries } from "../../services/ApiService";
import {
  resetClientFormData,
  setClientFormStruc,
  setInitialFormData,
} from "../../Redux/ClientFormSlice";
import { hasPermission } from "../GlobalFunction";
const { Option } = Select;

const ClientList = () => {
  const dispatch = useDispatch();
  const [allRequest, setAllRequest] = useState([]);
  const [total, setTotal] = useState(0);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
  });
  const fileInputRef = useRef(null);
  const [isImport, setIsImport] = useState(false);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateLoader, setUpdateLoader] = useState(false);
  const [countries, setCountries] = useState([]);
  const [countryLoader, setCountryLoader] = useState(false);
  const [filterPopoverVisible, setFilterPopoverVisible] = useState(false);
  const canCreateClient = hasPermission("client_list", "create");
  const canDeleteClient = hasPermission("client_list", "delete");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);

  const [searchFilters, setSearchFilters] = useState({
    client_name: "",
    client_billing_entity: "",
    type_of_client: "",
    country_of_employment: "",
  });

  const ClientType = [
    { label: "Direct", value: "direct" },
    { label: "Partner", value: "partner" },
  ];

  const navigate = useNavigate();

  const generateColumnsFromData = (Columnkeys) => {
    const keys = Columnkeys.filter(
      (item) =>
        item !== "client_id" &&
        item !== "client_name" &&
        item !== "id" &&
        item !== "status" &&
        item !== "created_date"
    );

    const dynamicColumns = keys.map((key) => ({
      title: key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      dataIndex: key,
      key: key,
      ellipsis: true,
      render: (text) => (
        <div style={{ minWidth: 100, whiteSpace: "nowrap" }}>
          {text && text !== "null" ? text : ""}
        </div>
      ),
    }));

    dynamicColumns.unshift({
      title: "Client Name",
      fixed: "left",
      key: "client_name",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            gap: "0.1rem",
            alignItems: "center",
          }}
        >
          <Avatar size={20} icon={<UserOutlined />} />
          <Button
            type="link"
            onClick={() => handleView(record)}
            style={{ fontSize: "0.8rem" }}
          >
            {`${record["client_name"]}`}
          </Button>
        </div>
      ),
      responsive: ["xs", "sm", "sm"],
    });

    return dynamicColumns;
  };

  const handleNew = async () => {
    try {
      setLoading(true);
      const res = await getClientFormStruc({
        country: "india",
      });
      if (res.responseCode === 200) {
        dispatch(setClientFormStruc(res.data));
        navigate("/client-onboard-form");
      } else {
        message.error(res.responseMessage);
      }
    } catch (error) {
      message.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async (page = 1, pageSize = 100, filters = {}) => {
    setLoading(true);
    try {
      let requestRes = await getAllClient(page, pageSize, filters, false);
      if (typeof requestRes === "string") {
        requestRes = requestRes.replace(/\bNaN\b/g, "null");
        requestRes = JSON.parse(requestRes);
      }
      if (requestRes?.responseCode === 200) {
        setTotal(requestRes?.client_data_record || 0);
        const Response = requestRes?.client_data;
        setAllRequest(Response);
        if (Response.length > 0) {
          const dynamicCols = generateColumnsFromData(requestRes?.column_list);
          setColumns(dynamicCols);
        } else {
          setColumns([]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const clearFilters = () => {
    const clearedFilters = {
      client_name: "",
      client_billing_entity: "",
      type_of_client: "",
      country_of_employment: "",
    };
    setSearchFilters(clearedFilters);
    setPagination((prev) => ({ ...prev, current: 1 }));
    fetchData(1, pagination.pageSize, clearedFilters, false);
  };

  const handleTableChange = (paginationInfo) => {
    const newPagination = {
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize,
    };
    setPagination(newPagination);
    fetchData(
      paginationInfo.current,
      paginationInfo.pageSize,
      searchFilters,
      false
    );
  };

  useEffect(() => {
    dispatch(resetClientFormData({}));
  }, []);

  useEffect(() => {
    fetchData(1, 50, {}, false);
    fetchCountry();
  }, []);

  const fetchCountry = async () => {
    try {
      setCountryLoader(true);

      const response = await getAllCountries(1);
      const rawObjects = response?.country_list ?? [];

      const CountryList = rawObjects
        .sort((a, b) => (a.country_name || "").localeCompare(b.country_name || ""))
        .map((item) => {
          // item.country_name is something like "Afghanistan(AF)"
          const fullString = item.country_name || "";
          // Extract clean name before the parenthesis: "Afghanistan"
          const cleanName = fullString.split("(")[0].trim();

          return {
            label: fullString, // User sees "Afghanistan(AF)" in the dropdown search
            value: cleanName,  // Passes "Afghanistan" which matches your database table records
          };
        });

      setCountries(CountryList);
    } catch (error) {
      console.error("Fetch error details:", error);
      message.error("Error in fetching Country Data");
    } finally {
      setCountryLoader(false);
    }
  };


  const handleView = async (record) => {
    try {
      const [formStructureRes, formDataRes] = await Promise.allSettled([
        getClientFormStruc({ country: "india" }),
        getClientFormData(record?.client_id),
      ]);
      if (
        formStructureRes.status === "fulfilled" &&
        formStructureRes?.value.responseCode === 200
      ) {
        dispatch(setClientFormStruc(formStructureRes?.value.data));
      }
      if (
        formDataRes.status === "fulfilled" &&
        formDataRes?.value.responseCode === 200
      ) {
        const parsedFormData = formDataRes?.value?.data;
        dispatch(setInitialFormData(parsedFormData));

        sessionStorage.setItem("client_id", record?.client_id);
        navigate("/update-form");
      } else {
        message.error("Failed to load Client data");
      }
    } catch (error) {
      message.error("Something went wrong!");
    }
  };

  const handleDownload = async () => {
    setLoading(true);
    try {
      let requestRes = await getAllClient(1, 1000, searchFilters, true);
      if (typeof requestRes === "string") {
        requestRes = requestRes.replace(/\bNaN\b/g, "null");
        requestRes = JSON.parse(requestRes);
      }

      if (requestRes?.responseCode === 200) {
        const Response = requestRes?.client_data;

        if (Array.isArray(Response)) {
          const cleanData = Response.map((row) =>
            Object.fromEntries(
              Object.entries(row).map(([key, value]) => [key, value ?? ""])
            )
          );

          const headers = requestRes?.column_list;

          const worksheet = XLSX.utils.json_to_sheet(cleanData, {
            header: headers,
          });

          const columnWidths = headers.map((header) => {
            const maxContentLength = Math.max(
              header.length,
              ...cleanData.map((row) =>
                row[header] ? String(row[header]).length : 0
              )
            );
            return { wch: maxContentLength + 2 };
          });
          worksheet["!cols"] = columnWidths;

          headers.forEach((header, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
            worksheet[cellRef] = worksheet[cellRef] || { t: "s", v: header };
            worksheet[cellRef].s = {
              font: {
                bold: true,
                color: { rgb: "FFFFFF" },
              },
              fill: {
                fgColor: { rgb: "4F81BD" },
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
              },
            };
          });

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Client_Directory_Sheet"
          );

          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          const fileData = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          saveAs(fileData, "Client_Directory_Sheet.xlsx");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBulkDelete = async () => {
    Modal.confirm({
      title: "Confirm Delete",
      content: `Are you sure you want to delete ${selectedRowKeys.length} selected requests?`,
      okText: "Yes, Delete",
      cancelText: "Cancel",
      centered: true,
      onOk: async () => {
        try {
          setIsDeleting(true);
          const res = await DeleteClientReq({ client_id: selectedRowKeys });
          if (res?.responseCode === 200) {
            message.success("Selected records deleted successfully");
            setSelectedRowKeys([]);
            fetchData(pagination.current, pagination.pageSize, searchFilters);
          } else {
            message.error(res?.responseMessage || "Failed to delete records");
          }
        } catch (error) {
          console.error(error);
          message.error("Something went wrong while deleting");
        } finally {
          setIsDeleting(false);
        }
      },
    });
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    setIsImport(true);
    try {
      let response = await UploadClientBulk(formData);

      if (typeof response === "string") {
        response = response.replace(/\bNaN\b/g, "null");
        response = JSON.parse(response);
      }

      if (response.responseCode === 200) {
        message.success("File uploaded successfully!");
        fetchData();
      } else {
        message.error(response.responseMessage || "Upload failed!");
      }
    } catch (error) {
      message.error("Something went wrong!");
      console.error("Error parsing or uploading:", error);
    } finally {
      setIsImport(false);
      event.target.value = null;
    }
  };

  const rowSelection =
    canDeleteClient
      ? {
          selectedRowKeys,
          onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
          getCheckboxProps: (record) => ({
            disabled: false,
          }),
        }
      : null;

    return (
    <>
      <div className="main-box">
        <Sidebar activeId={7} />
        <main className="main-content">
          <Spin
            spinning={loading || countryLoader || updateLoader}
            size="large"
            tip="Loading..."
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100vh",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
              }}
            >
              <Header title="Client Directory" />
              
              {/* Main content container */}
              <div style={{ flex: 1, padding: "1rem", overflowY: "auto", display: "flex", flexDirection: "column" }}>
                
                {/* Row 1: Filters in a visible single row + Clear button */}
                <div
                  style={{
                    display: "flex",
                    gap: "0.5rem",
                    alignItems: "center",
                    marginBottom: "0.75rem",
                    flexWrap: "wrap",
                  }}
                >
                  <Input
                    placeholder="Client Name"
                    prefix={<SearchOutlined />}
                    value={searchFilters.client_name}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchFilters((prev) => {
                        const updated = { ...prev, client_name: value };
                        setPagination((p) => ({ ...p, current: 1 }));
                        fetchData(1, pagination.pageSize, updated, false);
                        return updated;
                      });
                    }}
                    style={{ fontSize: "0.8rem", width: "150px" }}
                    allowClear
                  />

                  <Input
                    placeholder="Client Billing Entity"
                    prefix={<SearchOutlined />}
                    value={searchFilters.client_billing_entity}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchFilters((prev) => {
                        const updated = { ...prev, client_billing_entity: value };
                        setPagination((p) => ({ ...p, current: 1 }));
                        fetchData(1, pagination.pageSize, updated, false);
                        return updated;
                      });
                    }}
                    style={{ fontSize: "0.8rem", width: "150px" }}
                    allowClear
                  />

                  <Select
                    placeholder="Country of Employment"
                    showSearch
                    value={searchFilters.country_of_employment || undefined}
                    onChange={(value) => {
                      setSearchFilters((prev) => {
                        const updated = { ...prev, country_of_employment: value || "" };
                        setPagination((p) => ({ ...p, current: 1 }));
                        fetchData(1, pagination.pageSize, updated, false);
                        return updated;
                      });
                    }}
                    options={countries}
                    allowClear
                    optionFilterProp="label"
                    style={{ width: "160px" }}
                  />

                  <Select
                    placeholder="Type of Client"
                    showSearch
                    value={searchFilters.type_of_client || undefined}
                    onChange={(value) => {
                      setSearchFilters((prev) => {
                        const updated = { ...prev, type_of_client: value || "" };
                        setPagination((p) => ({ ...p, current: 1 }));
                        fetchData(1, pagination.pageSize, updated, false);
                        return updated;
                      });
                    }}
                    options={ClientType}
                    allowClear
                    optionFilterProp="label"
                    style={{ width: "140px" }}
                  />

                  <Button
                    onClick={() => {
                      clearFilters();
                    }}
                    style={{ color: "red", borderColor: "#ff4d4f" }}
                  >
                    Clear
                  </Button>

                  {canCreateClient && (
                    <Tooltip title="Add New Client">
                      <Button
                        shape="circle"
                        type="primary"
                        onClick={() => handleNew()}
                        style={{ backgroundColor: "black", color: "white" }}
                        icon={<PlusCircleOutlined />}
                      />
                    </Tooltip>
                  )}

                  <Tooltip title="Download Excel">
                    <Button
                      shape="circle"
                      style={{
                        backgroundColor: "#097249",
                        color: "white",
                      }}
                      onClick={handleDownload}
                      icon={<DownloadOutlined />}
                    />
                  </Tooltip>

                  {canCreateClient && (
                    <>
                      <Tooltip title="Import Client">
                        <Button
                          shape="circle"
                          disabled={isImport}
                          onClick={() => fileInputRef.current.click()}
                          icon={isImport ? <LoadingOutlined /> : <UploadOutlined />}
                        />
                      </Tooltip>

                      <input
                        type="file"
                        accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                    </>
                  )}

                  {canDeleteClient && (
                    <Tooltip
                      title={
                        selectedRowKeys.length > 0
                          ? `Delete Selected (${selectedRowKeys.length})`
                          : "Delete Selected"
                      }
                    >
                      <Badge
                        count={selectedRowKeys.length}
                        overflowCount={99}
                        offset={[-2, 2]}
                      >
                        <Button
                          danger
                          shape="circle"
                          icon={
                            isDeleting ? <LoadingOutlined /> : <DeleteOutlined />
                          }
                          disabled={selectedRowKeys.length === 0 || isDeleting}
                          onClick={handleBulkDelete}
                        />
                      </Badge>
                    </Tooltip>
                  )}
                </div>

                {/* Table Body with fixed scroll area */}
                <Table
                  columns={columns}
                  dataSource={allRequest}
                  rowSelection={canDeleteClient ? rowSelection : null}
                  rowKey="client_id"
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: total,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} records`,
                  }}
                  onChange={handleTableChange}
                  scroll={{ x: "max-content", y: "calc(100vh - 280px)" }}
                  style={{
                    fontSize: "0.7rem",
                    borderRadius: "1.5rem",
                    background: "#FFF",
                    flex: 1,
                    minHeight: "calc(100vh - 280px)",
                  }}
                  className="masterTb custom-scrollbar"
                />
              </div>
            </div>
          </Spin>
        </main>
      </div>
    </>
  );
};

export default ClientList;
